export function initials(name: string | null | undefined): string {
  const words = (name ?? '').trim().split(/\s+/).filter(Boolean);
  if (words.length === 0) return '?';
  return words.slice(0, 2).map((word) => word[0]!.toUpperCase()).join('');
}

export function displayOrDash(value: unknown): string {
  if (value === null || value === undefined || value === '') return 'Not provided';
  return String(value);
}

const MONTHS = [
  'January', 'February', 'March', 'April', 'May', 'June',
  'July', 'August', 'September', 'October', 'November', 'December',
];

export function formatDate(iso: string | null | undefined): string {
  if (!iso) return '';
  const [year, month, day] = iso.slice(0, 10).split('-');
  if (!year || !month || !day) return iso;
  return `${Number(day)} ${MONTHS[Number(month) - 1]} ${year}`;
}

export function formatDateTime(iso: string | null | undefined): string {
  if (!iso) return '';
  const date = new Date(iso);
  return `${formatDate(date.toISOString())} at ${date.toLocaleTimeString([], {
    hour: '2-digit', minute: '2-digit',
  })}`;
}

export function formatRelative(iso: string | null | undefined): string {
  if (!iso) return '';
  const seconds = Math.round((Date.now() - new Date(iso).getTime()) / 1000);
  if (seconds < 60) return 'just now';
  const units: Array<[number, Intl.RelativeTimeFormatUnit]> = [
    [60, 'minute'], [3600, 'hour'], [86400, 'day'], [604800, 'week'],
    [2629800, 'month'], [31557600, 'year'],
  ];
  let chosen = units[0]!;
  for (const unit of units) if (seconds >= unit[0]) chosen = unit;
  return new Intl.RelativeTimeFormat(undefined, { numeric: 'auto' })
    .format(-Math.floor(seconds / chosen[0]), chosen[1]);
}
